import { render, staticRenderFns } from "./Newspaper.vue?vue&type=template&id=93174c76&"
import script from "./Newspaper.vue?vue&type=script&setup=true&lang=js&"
export * from "./Newspaper.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports